import React, { useState } from 'react';
import { useNavigation } from '../../context/NavigationContext';
import { BringzzIcon, BringzzRadio, BringzzRadioList, BringzzBottomDrawer } from "@bringzz/components";
import Logo from '../../assets/BringzzLogo.png';
import './sidebar.css';
import classNames from 'classnames';
import { returnMenuList, handleMenuNavigation } from 'utils';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

const state = {
	checked: <div></div>,
	unChecked: <div></div>
};

const Sidebar = () => {
	const { navigate, isActive } = useNavigation();
	const { user } = useAuth();
	const { t } = useTranslation();
	const { t: tMenu } = useTranslation('menu');
	const [pickerDrawerOpened, setPickerDrawerOpened] = useState(null);

	const handlePickerClick = async choice => {
		if (choice == "external_link") {
			navigate('/posts/add', {
				state: {type: 2}
			})
		} else if (choice == "product_post") {
			navigate('/posts/add', {
				state: {type: 3}
			})
		} else if (choice == "article_post") {
			navigate('/posts/add', {
				state: {type: 1}
			})
		}
	}

	return (
		<>
			<div className='flex flex-col items-start w-64 h-screen sticky top-0 border border-r-zinc-300 p-5'>
				<div>
					<img
						src={Logo}
						alt={t('component.sidebar.logo_alt')}
						className='h-7 my-5 pl-2 cursor-pointer'
					></img>
				</div>
				<div className='space-y-2 w-full'>
					{user && returnMenuList(user.userRole).map((item, index) => {
						const active = isActive(item.url);

						return (
							<div
								key={index}
								className={classNames(
									'menu-item flex space-x-4 px-3 py-3 hover:bg-zinc-100 hover:font-bold w-full rounded-lg cursor-pointer',
									active ? 'font-bold bg-zinc-100' : ''
								)}
								onClick={() => handleMenuNavigation(item, navigate, setPickerDrawerOpened)}
							>
								<BringzzIcon
									icon={item.icon}
									folder={item.folder}
									size='23'
									className={classNames(
										'scale-target',
										active ? 'scale-[1.1]' : ''
									)}
								/>
								<div>{tMenu(item.label)}</div>
							</div>
						);
					})}
				</div>
			</div>
			<BringzzBottomDrawer
				isOpen={pickerDrawerOpened}
				title={t('component.sidebar.select_post_type')}
				close={() => setPickerDrawerOpened(false)}
			>
				<div className='px-4 py-6'>
					<BringzzRadioList
						state={state}
						className='rounded-xl w-full text-center'
						onChange={choice => {
							handlePickerClick(choice);
							setPickerDrawerOpened(false);
						}}
					>
						<BringzzRadio
							value='external_link'
							className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400 flex'
						>
							<div>{t('component.sidebar.external_link')}</div>
						</BringzzRadio>
						<BringzzRadio
							value='product_post'
							className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400'
						>
							<div>{t('component.sidebar.product_post')}</div>
						</BringzzRadio>
						<BringzzRadio
							className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400'
							value='article_post'
						>
							<div>{t('component.sidebar.article_post')}</div>
						</BringzzRadio>
					</BringzzRadioList>
				</div>
			</BringzzBottomDrawer>
		</>
	);
};

export default Sidebar;
